import fp from 'lodash/fp'
import React, { Component } from 'react'
import { translate } from 'react-multi-lang'
import Images from '../constants/images-wines'
import addBrTag from '../utils/add-br-tag'
import Services from '../services'

import './wines.css';

class Wines extends Component {

	static displayName = 'Wines'

	constructor(props) {

		super(props)

		const textToDisplay = fp.reduce((acc, { uid }) => ({
			...acc,
			[uid]: 'product'
		}), {}, Images)

		this.state = {
			premium: true,
			prices: [],
			textToDisplay,
			tabProducer: 'not-selected-tab',
			tabProduct: 'selected-tab'
		}
	}

	componentDidMount() {

		Services.getPrices().then(({ prices }) => {

			this.setState({ prices })
		})
	}

	onProductClicked = ({ target }) => {

		const newTextToDisplay = {
			...this.state.textToDisplay,
			[target.id]: 'product'
		}

		this.setState({
			textToDisplay: newTextToDisplay
		})
	}

	onProducerClicked = ({ target }) => {

		const newTextToDisplay = {
			...this.state.textToDisplay,
			[target.id]: 'producer'
		}

		this.setState({
			textToDisplay: newTextToDisplay
		})
	}

	getLabel = (uid, key) => {

		const { t } = this.props

		return t(`key_words.${key}`) + ": " + t(`products.${uid}.${key}`)
	}

	onDisplayPremium = () => {

		this.setState({
			premium: !this.state.premium
		})
	}

	render() {

		const { t } = this.props
		const { textToDisplay } = this.state
		const prices = this.state.prices


		return (
			<div className='products'>

				{fp.map(({ alt, src, uid }) => {

					const index = fp.findIndex({ uid: uid }, prices)
					const price = index !== -1 ? prices[index].price : ""
					const outOfStock = index !== -1 ? prices[index].outOfStock : false
					const premium = index !== -1 ? prices[index].premium : false

					const producer1 = t(`products.${uid}.producer_part1`)
					const producer2 = t(`products.${uid}.producer_part2`)
					const producer3 = t(`products.${uid}.producer_part3`)
					const producer4 = t(`products.${uid}.producer_part4`)

					// return ((this.state.premium === false && premium !== true) || this.state.premium === true)
					return (premium !== true)
						&& <div key={uid} className='wrapper'>

							<div className='title-wrapper'>
								<h2 className='product-title'>
									{t(`products.${uid}.title`)}
								</h2>
								{price && <div className={`${outOfStock ? 'price barre' : 'price'}`}>{price}</div>}
							</div>

							<div className='sub-wrapper'>

								<div className='image'>
									<img alt={alt} key={uid} {...{
										height: 400,
										src,
									}} />
								</div>

								<div className='product-text'>
									<div className='tabs-button'>
										<div className={`tab-button ${textToDisplay[uid] === 'product' ? 'tab-selected' : 'tab-not-selected'}`} id={uid} onClick={this.onProductClicked}>
											{t(`buttons.product`)}
										</div>
										<div className={`tab-button ${textToDisplay[uid] === 'producer' ? 'tab-selected' : 'tab-not-selected'}`} id={uid} onClick={this.onProducerClicked}>
											{t(`buttons.producer`)}
										</div>
									</div>

									{textToDisplay[uid] === 'product' ?
										<div className='description'>
											<div className=''>{this.getLabel(uid, 'producer')}</div>
											<div className=''>{this.getLabel(uid, 'area')}</div>
											<div className=''>{this.getLabel(uid, 'vintage')}</div>
											<div className=''>{this.getLabel(uid, 'color')}</div>
											<div className=''>{this.getLabel(uid, 'grape')}</div>
											<div className=''>{this.getLabel(uid, 'alcohol')}</div>
											<div className=''>{this.getLabel(uid, 'barrel')}</div>
											<br />
											<div>
												<span className='bold-underline'>{t(`key_words.distinction`)}</span>
												<span>{addBrTag(t(`products.${uid}.distinction`))}</span>
											</div>
											<br />
											<div className='bold-underline'>{t(`key_words.tasting`)}</div>
											<div className=''>{this.getLabel(uid, 'tasting.robe')}</div>
											<div className=''>{this.getLabel(uid, 'tasting.nose')}</div>
											<div className=''>{this.getLabel(uid, 'tasting.palate')}</div>
											<br />
											<div className='bold-underline'>{t(`key_words.sommelier_advice`)}</div>
											<div className=''>{t(`products.${uid}.sommelier_advice.keeping`)}</div>
											<div className=''>{t(`products.${uid}.sommelier_advice.temp`)}</div>
										</div>
										: <div className='description'>
											{producer1 !== " " && <div className='paragraph'>{addBrTag(producer1)}</div>}
											{producer2 !== " " && <div className='paragraph'>{addBrTag(producer2)}</div>}
											{producer3 !== " " && <div className='paragraph'>{addBrTag(producer3)}</div>}
											{producer4 !== " " && <div className='paragraph'>{addBrTag(producer4)}</div>}
										</div>
									}
								</div>

							</div>

						</div>
				}, Images)}


				<div className='premiums-wrapper'>
					<div className='premiums'>Premiums</div>
				</div>

				{fp.map(({ alt, src, uid }) => {

					const index = fp.findIndex({ uid: uid }, prices)
					const price = index !== -1 ? prices[index].price : ""
					const outOfStock = index !== -1 ? prices[index].outOfStock : false
					const premium = index !== -1 ? prices[index].premium : false

					const producer1 = t(`products.${uid}.producer_part1`)
					const producer2 = t(`products.${uid}.producer_part2`)
					const producer3 = t(`products.${uid}.producer_part3`)
					const producer4 = t(`products.${uid}.producer_part4`)

					return (premium === true)
						&& <div key={uid} className='wrapper'>

							<div className='title-wrapper'>
								<h2 className='product-title'>
									{t(`products.${uid}.title`)}
								</h2>
								{price && <div className={`${outOfStock ? 'price barre' : 'price'}`}>{price}</div>}
							</div>

							<div className='sub-wrapper'>

								<div className='image'>
									<img alt={alt} key={uid} {...{
										height: 400,
										src,
									}} />
								</div>

								<div className='product-text'>
									<div className='tabs-button'>
										<div className={`tab-button ${textToDisplay[uid] === 'product' ? 'tab-selected' : 'tab-not-selected'}`} id={uid} onClick={this.onProductClicked}>
											{t(`buttons.product`)}
										</div>
										<div className={`tab-button ${textToDisplay[uid] === 'producer' ? 'tab-selected' : 'tab-not-selected'}`} id={uid} onClick={this.onProducerClicked}>
											{t(`buttons.producer`)}
										</div>
									</div>

									{textToDisplay[uid] === 'product' ?
										<div className='description'>
											<div className=''>{this.getLabel(uid, 'producer')}</div>
											<div className=''>{this.getLabel(uid, 'area')}</div>
											<div className=''>{this.getLabel(uid, 'vintage')}</div>
											<div className=''>{this.getLabel(uid, 'color')}</div>
											<div className=''>{this.getLabel(uid, 'grape')}</div>
											<div className=''>{this.getLabel(uid, 'alcohol')}</div>
											<div className=''>{this.getLabel(uid, 'barrel')}</div>
											<br />
											<div>
												<span className='bold-underline'>{t(`key_words.distinction`)}</span>
												<span>{addBrTag(t(`products.${uid}.distinction`))}</span>
											</div>
											<br />
											<div className='bold-underline'>{t(`key_words.tasting`)}</div>
											<div className=''>{this.getLabel(uid, 'tasting.robe')}</div>
											<div className=''>{this.getLabel(uid, 'tasting.nose')}</div>
											<div className=''>{this.getLabel(uid, 'tasting.palate')}</div>
											<br />
											<div className='bold-underline'>{t(`key_words.sommelier_advice`)}</div>
											<div className=''>{t(`products.${uid}.sommelier_advice.keeping`)}</div>
											<div className=''>{t(`products.${uid}.sommelier_advice.temp`)}</div>
										</div>
										: <div className='description'>
											{producer1 !== " " && <div className='paragraph'>{addBrTag(producer1)}</div>}
											{producer2 !== " " && <div className='paragraph'>{addBrTag(producer2)}</div>}
											{producer3 !== " " && <div className='paragraph'>{addBrTag(producer3)}</div>}
											{producer4 !== " " && <div className='paragraph'>{addBrTag(producer4)}</div>}
										</div>
									}
								</div>

							</div>

						</div>
				}, Images)}

				{/* 
				<button {...{
					children: this.state.premium ? t('buttons.premium_hide') : t('buttons.premium_display'),
					className: 'premium',
					onClick: this.onDisplayPremium
				}} /> */}

			</div>
		)
	}
}

export default translate(Wines)